import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-735b4be7"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M25.6077 14.2944C25.2138 13.9073 24.5807 13.9127 24.1936 14.3066L19.9878 18.5857L15.7088 14.3801C15.3149 13.9929 14.6817 13.9984 14.2946 14.3923C13.9075 14.7862 13.913 15.4193 14.3068 15.8065L18.5859 20.0121L14.3801 24.2914C13.9929 24.6853 13.9984 25.3184 14.3923 25.7055C14.7862 26.0927 15.4193 26.0872 15.8065 25.6933L20.0123 21.4141L24.2916 25.62C24.6855 26.0071 25.3186 26.0016 25.7058 25.6077C26.0929 25.2138 26.0874 24.5807 25.6935 24.1936L21.4142 19.9877L25.6199 15.7086C26.0071 15.3147 26.0016 14.6815 25.6077 14.2944Z",
    fill: "#999999"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { onBeforeUnmount, onMounted, ref } from "vue";
import { TSwipe } from "../../globals";


export default /*#__PURE__*/_defineComponent({
  __name: 'PopupContainer',
  props: {
    isSwipeEnabled: { type: Boolean, default: true }
  },
  emits: ["blur", "close", "swipe", "scroll"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

onMounted(() => {
  lockWindowScroll();
});

onBeforeUnmount(() => {
  unlockWindowScroll();
});

function onBlurHandler() {
  emit("blur");
}

function lockWindowScroll() {
  document.documentElement.style.overflow = "hidden";
}

function unlockWindowScroll() {
  document.documentElement.style.overflow = "";
}

function onSwipeHandler(direction: TSwipe) {
  if (!props.isSwipeEnabled) {
    return;
  }

  emit("swipe", direction);
}

const contentWrapper = ref<HTMLElement | null>(null);
const contentWrapperSlot = {
  scrollToTop,
};
function scrollToTop() {
  contentWrapper.value?.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

function scrollHandler(e: Event) {
  const target = e.target as HTMLElement;
  const scrollTop = target.scrollTop;

  // Scroll position event
  const scrollBottom = target.scrollHeight - (target.offsetHeight + scrollTop);
  emit("scroll", {
    top: scrollTop,
    bottom: scrollBottom,
  });
}

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "frisbuy-popup-container",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => onBlurHandler(), ["self"]))
  }, [
    _createElementVNode("div", {
      class: "frisbuy-popup-container__content-wrapper",
      ref_key: "contentWrapper",
      ref: contentWrapper,
      onScroll: _cache[1] || (_cache[1] = (e) => scrollHandler(e))
    }, [
      _renderSlot(_ctx.$slots, "closeButton", {}, () => [
        _createElementVNode("button", {
          class: "frisbuy-close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, _hoisted_2)
      ]),
      _renderSlot(_ctx.$slots, "content", _normalizeProps(_guardReactiveProps(contentWrapperSlot)))
    ], 544)
  ])), [
    [_directive_touch, (direction) => onSwipeHandler(direction), "swipe"]
  ])
}
}

})